import script from "./KeywordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KeywordModal.vue?vue&type=script&setup=true&lang=js"

import "./KeywordModal.vue?vue&type=style&index=0&id=16f6d9be&scoped=true&lang=css"
script.__scopeId = "data-v-16f6d9be"

export default script